import type { CSSProperties } from 'react';
import styles from './MainView.module.css';
import type { IFloorplanViewModel } from './interface';

export enum StyleElement {
    Container = 'Container',
    ItemContainer = 'ItemContainer',
    Item = 'Item',
    PageControl = 'PageControl',
    ButtonPlus = 'ButtonPlus',
    ButtonMinus = 'ButtonMinus',
    IconPlus = 'IconPlus',
    IconMinus = 'IconMinus',
}

const DEFAULTS: Record<StyleElement, CSSProperties> = {
    [StyleElement.Container]: {},
    [StyleElement.ItemContainer]: {},
    [StyleElement.Item]: {},
    [StyleElement.PageControl]: {},
    [StyleElement.ButtonPlus]: {},
    [StyleElement.ButtonMinus]: {},
    [StyleElement.IconPlus]: {},
    [StyleElement.IconMinus]: {},
};

const PROPS_APPLICATOR: Record<StyleElement, (properties: IFloorplanViewModel) => CSSProperties> = {
    [StyleElement.Container]: (properties: IFloorplanViewModel) => ({
        backgroundColor: properties.backgroundColor,
    }),
    [StyleElement.ItemContainer]: (properties: IFloorplanViewModel) => ({
        width: `${properties.items.length * 100}vw`,
    }),
    [StyleElement.Item]: (properties: IFloorplanViewModel) => ({}),
    [StyleElement.PageControl]: (properties: IFloorplanViewModel) => ({
        display: properties.items.length > 1 ? 'auto' : 'none',
        /* Grow the width (to a max 60vmin) to cater for more 'dots' */
        width: `${Math.min(properties.items.length * 5 + 24, 60)}vmin`,
    }),
    [StyleElement.ButtonPlus]: (properties: IFloorplanViewModel) => ({}),
    [StyleElement.ButtonMinus]: (properties: IFloorplanViewModel) => ({}),
    [StyleElement.IconMinus]: (properties: IFloorplanViewModel) => ({
        color: properties.zoomControlsBackgroundColor,
        borderColor: properties.zoomControlsTintColor,
        backgroundColor: properties.zoomControlsTintColor,
    }),
    [StyleElement.IconPlus]: (properties: IFloorplanViewModel) => ({
        color: properties.zoomControlsBackgroundColor,
        borderColor: properties.zoomControlsTintColor,
        backgroundColor: properties.zoomControlsTintColor,
    }),
};

export function classNameForElement(
    element: StyleElement,
    properties: IFloorplanViewModel,
): string {
    const name = element.toString();
    return styles[name] ?? '';
}

export function styleForElement(
    element: StyleElement,
    properties: IFloorplanViewModel,
    overrides?: CSSProperties,
): CSSProperties {
    const style = { ...DEFAULTS[element], ...PROPS_APPLICATOR[element](properties), ...overrides };

    return style;
}
